/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';

import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import ListSubheader from '@material-ui/core/ListSubheader'

import Action from '../../Actions/ActionFactory'

const styles = theme => ({

})

const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 250,
      },
    },
  };
  

class FDropDown extends Component {
    state = {
        result : [],
        retreived_options : false,
        options : [],
        err: false,
        err_message : "",
        val_key : "value",
        label_key : "label"
    }

    componentWillMount () {
        //this.getValues()
        if (this.props.instance.async_values === true) {
            this.getValues()
        } else {
            this.setState({...this.state, options : this.props.instance.values}, () => console.log("Drop Down State :" , this.state))
        }
    }

    getValues = () => {
        if (this.props.instance.async_values === true) {
            Action('http_request', this.props.instance.api_config.args)
            .then ((res) => {
                console.log("Response: ", res)
                let list_key = this.props.instance.api_config.response_key.split(".")
                let address = ["data"].concat(list_key)
                //console.log('Address: ', address)
                
                let raw_list = address.reduce((object, key) => {
                    return object[key]
                }, res)

                let list = []
                if (this.identifyStringListType(raw_list)) {
                    list = this.formatList(raw_list)
                    this.setState({val_key : "value"})
                } else {
                    list = raw_list
                    this.setState({val_key : this.props.instance.api_config.val_key, label_key: this.props.instance.api_config.label_key })
                }
                this.setState({options : list, retreived_options : true}, () => console.log('Drop Down State: ', this.state))
            })
            .catch ((err) => {
                console.log("Error Retrieving Options: ", err)
                this.setState({
                    err : true,
                    err_message: err,
                    retreived_options : true
                })
            })
        } else {
            this.setState({...this.state, options : this.props.instance.values, val_key : "value"})
        }
    }

    identifyStringListType = (array) => {
        if (typeof array[0] === 'string') {
            return true
        } else {
            return false
        }
    }

    formatList = (raw_list) => {
        let new_list = raw_list.map(val => {
            return {
                value : val,
                label : val.toUpperCase()
            }
        })

        return new_list
    }

    renderMenuItem = () => {
        let menu = []
        const props = this.props.instance
        console.log('Options :', this.state.options)
        if (props.async_values === true) {
            if (this.state.retreived_options) {
                if (this.state.options.length !== 0) {
                    if (this.props.instance.grouped) {
                        if (this.props.instance.group_key !== null) {
                            let groups = new Set()
                            this.state.options.forEach(option => {
                                groups.add(option[this.props.instance.group_key])
                            })

                            let grouped_options = []

                            for (let group of groups) {
                                let new_group = {
                                    group_name : group,
                                    options : []
                                }
                                grouped_options.push(new_group)
                            }


                            grouped_options.forEach(group => {
                                this.state.options.forEach(option => {
                                    if (option[this.props.instance.group_key] === group.group_name) {
                                        group.options.push(option)
                                    }
                                })
                            })

                            grouped_options.forEach((group, i) => {
                                menu.push(<ListSubheader style = {{backgroundColor : '#FFFFFF'}}>{group.group_name}</ListSubheader>)   
                                group.options.forEach(option => {
                                    menu.push(<MenuItem style = {{marginLeft : '10px'}} value = {option[this.state.val_key]}>{this.state.label_key !== '' ? option[this.state.label_key]: option[this.state.val_key]}</MenuItem>)
                                }) 
                            })
                        }
                    } else {
                        menu = this.state.options.map(option => {
                            return (
                                <MenuItem value = {option[this.state.val_key]}>{this.state.label_key !== '' ? option[this.state.label_key]: option[this.state.val_key]}</MenuItem>
                            )
                        })
                    }
                } else {
                    menu = [0].map(val => {
                        return (
                            <MenuItem disabled ><em>No Options to choose</em></MenuItem>
                        )
                    })
                }
            } else {
                return (
                    <MenuItem disabled ><em>Getting Options...</em></MenuItem>
                )
            }
        } else {
            menu = this.state.options.map(option => {
                return (
                    <MenuItem value = {option[this.state.val_key]}>{option[this.state.label_key]}</MenuItem>
                )
            })
        }

        return menu
    }

    render() {
        return (
            <FormControl
            style = {{
                width: '100%'
            }}
            id = {this.props.instance.id}
            variant = {this.props.instance.props.variant}
            size = {this.props.instance.size}
            required = {this.props.instance.mandatory}
            disabled = {this.props.instance.disabled}
            error = {this.props.instance.error}
            >
                <InputLabel>{this.props.instance.label}</InputLabel>
                {console.log('Drop Down Value :', this.props.instance.value)}
                <Select
                    value = {this.props.instance.value}
                    defaultValue = {this.props.instance.default_value}
                    error = {this.props.instance.error}
                    onOpen = {this.getValues}
                    onBlur = {this.props.instance.onBlur}
                    MenuProps={MenuProps}
                    onChange = {(event) => {
                        console.log("Clicked Item : ", event.target.value)
                        this.props.handleChange([this.props.instance.value_store[this.props.instance.value_store.length - 1]], event.target.value, this.props.instance.id)
                    }}
                >
                    {this.renderMenuItem()}
                </Select>
                <FormHelperText>{this.props.instance.helper_text}</FormHelperText>
            </FormControl>
        );
    }
}

export default withStyles(styles)(FDropDown);